export const NAVIGATION_TEXTS = [
  // {
  //   text: 'Services',
  //   textId: 'navigation.service',
  //   id: 'services',
  //   pages: [
  //     {
  //       text: 'React Native Mobile App Development',
  //       href: '',
  //     },
  //     {
  //       text: 'React / Node Web Development',
  //       href: '',
  //     },
  //     {
  //       text: 'Legacy App Modernization',
  //       href: '',
  //     },
  //     {
  //       text: 'UI/UX Development',
  //       href: '',
  //     },
  //     {
  //       text: 'Quality Assurance',
  //       href: '',
  //     },
  //     {
  //       text: 'IT Staff Augmentation',
  //       href: '',
  //     },
  //   ],
  // },
  {
    text: 'navigation_expertise',
    textId: 'navigation.expertise',
    id: 'expertise',
    pages: [
      {
        text: 'navigation_expertise_ble',
        href: 'navigation_expertise_ble_href',
      },
      {
        text: 'navigation_expertise_emsp',
        href: 'navigation_expertise_emsp_href',
      },
      {
        text: 'navigation_expertise_meditation',
        href: 'navigation_expertise_meditation_href',
      },
      {
        text: 'navigation_expertise_fitness',
        href: 'navigation_expertise_fitness_href',
      },
      {
        text: 'navigation_expertise_iot',
        href: 'navigation_expertise_iot_href',
      },
      {
        text: 'navigation_expertise_ev',
        href: 'navigation_expertise_ev_href',
      },
      {
        text: 'navigation_expertise_wearable',
        href: 'navigation_expertise_wearable_href',
      },
      {
        text: 'navigation_expertise_iomt',
        href: 'navigation_expertise_iomt_href',
      },
    ],
  },
  {
    text: 'navigation_portfolio',
    textId: 'navigation.portfolio',
    href: '/portfolio/',
    id: 'portfolio',
  },
  {
    text: 'navigation_company',
    textId: 'navigation.company',
    id: 'company',
    pages: [
      {
        text: 'navigation_company_about',
        href: '/about-us/',
      },
      { text: 'navigation_company_careers', href: '/careers/', subText: '' },
    ],
  },

  {
    text: 'navigation_blog',
    textId: 'navigation.blog',
    href: '/blog/',
    id: 'blog',
  },
];
